import { observer } from "mobx-react";
import React from "react";
import { getDisplayDate } from "../../utils/functions";
import FilterAllocation from "../FilterAllocation/FilterAllocation";
import MoneyValue from "../MoneyValue/MoneyValue";
import infoInfinity from "../../assets/images/svg/infoInfinity.svg";
import { ReactComponent as InfinityBackground } from "../../assets/images/svg/infinityBackground.svg";
import UserStore from "../../store/UserStore";

const InfinityValueContainer = observer(
  ({ data, allocation, tooltipModalOpen, setToolTipModalOpen }) => {
    return (
      <>
        <div
          style={{
            position: "relative",
          }}
        >
          <InfinityBackground style={{ width: "100%" }} />
          <div
            style={{
              position: "absolute",
              top: "0px",
              width: "100%",
            }}
          >
            <div className="inifinty_value_container_out ">
              <div className="infinity_money_value_container  subAssetLevel ">
                <MoneyValue
                  title="Current Value"
                  modalLogo={infoInfinity}
                  setToolTipModalOpen={(data) => setToolTipModalOpen(data)}
                  amount={`${UserStore.infinityHoldingData?.investmentreturn?.current_value?.value} `}
                  unitType={
                    UserStore.infinityHoldingData?.investmentreturn
                      ?.current_value?.value_type || ""
                  }
                  date1={`As of ${
                    getDisplayDate(
                      UserStore.infinityHoldingData?.investmentreturn
                        ?.as_of_date
                    ) || ""
                  }`}
                  hasBackground={true}
                  hasWidth={true}
                />

                <MoneyValue
                  title="Invested Value"
                  amount={`${
                    UserStore.infinityHoldingData?.investmentreturn
                      ?.invested_value?.value || "-"
                  }`}
                  unitType={
                    UserStore.infinityHoldingData?.investmentreturn
                      ?.invested_value?.value_type || ""
                  }
                  hasBackground={true}
                  hasWidth={true}
                />
                <MoneyValue
                  title="Total Gains"
                  amount={`${
                    UserStore.infinityHoldingData?.investmentreturn
                      ?.total_returns?.value || "-"
                  } `}
                  unitType={
                    UserStore.infinityHoldingData?.investmentreturn
                      ?.total_returns?.value_type || ""
                  }
                  batchAmount={
                    UserStore.infinityHoldingData?.investmentreturn
                      ?.unrealised_gain?.percentage
                  }
                  hasBackground={true}
                  hasWidth={true}
                />

                <MoneyValue
                  title="IRR"
                  infoLogo={infoInfinity}
                  amount={`${
                    UserStore.infinityHoldingData?.investmentreturn?.irr || "-"
                  }%`}
                  hasBackground={true}
                  hasWidth={true}
                  tile="infinity"
                  TooltipContent={
                    <div className="irr_tip">
                      <h2>IRR</h2>
                      <p>This is returns since inception(first purchase)</p>
                    </div>
                  }
                  tipClass="assetLevel"
                />
              </div>

              {allocation !== undefined && (
                <div className="infinity_value_allocation">
                  <FilterAllocation
                    textColor="white"
                    title={"Allocation"}
                    percentageAmout={allocation}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default InfinityValueContainer;
